import React, { useCallback, useState } from 'react';
import {
  useGetAddressesQuery,
  useUpdateOrderMutation,
} from '../../apis/mlkApi/mlk.api.hooks';
import Layout, { OrderRequestResult } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { AddressElement } from './components/AddressElement/AddressElement/AddressElement';

import './ChooseFavoriteAddressView.css';
import { Button } from '../../components/Button/Button';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../routes/types';
import { parseRes } from '../../apis/utils';

type ChooseFavoriteAddressViewProps = {};

export const ChooseFavoriteAddressView: React.FC<
  ChooseFavoriteAddressViewProps
> = () => {
  const [t] = useLanguage();
  const history = useHistory();
  const goBack = useBack();
  const [selectedAddressId, setSelectedAddressId] = useState<number>();
  const [updateAddress] = useUpdateOrderMutation();
  const [orderId, setOrderId] = useState<number>();

  const { data: addressesData } = useGetAddressesQuery(undefined);

  const editDeliveryAddress = useCallback(() => {
    const address = addressesData!.data!.find(
      (a) => selectedAddressId === a.id
    );
    if (address && orderId) {
      updateAddress({
        orderId: `${orderId}`,
        address: {
          address: address.address,
          lat: address.lat,
          lon: address.lon,
          number: address.number,
          route: address.route,
          zipCode: address.zipCode,
          city: address.city,
          country: address.country,
          doorbellLatitude: address.doorbellLatitude,
          doorbellLongitude: address.doorbellLongitude,
        },
        reception: address.reception ? address.reception : undefined,
        instructions: {
          floorNumber: address.floorNumber ? address.floorNumber : undefined,
          instructions: address.instructions ?? '',
          doorbell: address.doorbell,
          elevator: address.elevator,
        },
      }).then((res) => {
        const { successRes, errorRes } = parseRes(res);
        if (successRes.data) {
          history.replace(Routes.Home);
        }
        if (errorRes.error) {
          // TODO: Handle error
          console.log(errorRes.error);
        }
      });
    }
  }, [addressesData, history, orderId, selectedAddressId, updateAddress]);

  const goToNewAddress = useCallback(() => {
    history.push(Routes.CreateAddress, { isFromChangeAddress: true });
  }, [history]);

  const onOrderUpdate = useCallback((orderResult: OrderRequestResult) => {
    setOrderId(orderResult.data?.id);
  }, []);

  return (
    <Layout
      hasBack
      hasViewportHeight
      onBackClick={goBack}
      onOrderChange={onOrderUpdate}
      title={t('pageTitles.addresses')}
    >
      <div className="choose-favorite-address--list">
        {addressesData &&
          addressesData.data.map((a) => {
            return (
              <AddressElement
                addressId={a.id}
                isSelected={a.id === selectedAddressId}
                onClick={() => {
                  setSelectedAddressId(a.id);
                }}
                addressFirstPart={`${a.route} ${a.number}`}
                addressName={a.name}
                addressType={a.addressType}
                addressSecondPart={`${a.zipCode} ${a.city}`}
                key={a.id}
              />
            );
          })}
      </div>
      <div className="choose-favorite-address--buttons">
        <Button
          isDisabled={selectedAddressId === undefined}
          label={t('chooseFavoriteAddress.selectAddress')}
          onClick={editDeliveryAddress}
          isPrimary
        />
        <div className="choose-favorite-address--last-button">
          <Button
            onClick={goToNewAddress}
            label={t('chooseFavoriteAddress.addNew')}
          />
        </div>
      </div>
    </Layout>
  );
};
